import { checkIsClientSide } from './checkIsClientSide';

export const getBaseURL = (): string => {
  if (!checkIsClientSide()) return '';

  const url = new URL(window.location.href);
  return `${url.origin}${url.pathname}`;
};
